import {
  Alert,
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  useTheme,
} from "@mui/material";
import { FormFields } from "./Fields";
import ErrorsList from "../../ui/ErrorsList";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useSite } from "../Sites/Provider";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate, useParams } from "react-router-dom";
import { useCompany } from "../Companies/Provider";
import { CalUtcWithFormat, newValueConvert } from "../../utilities/functions";
import { useReservation } from "./provider";
import { useAuth } from "../../services/auth";
import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/en-gb";

const yupSchema = FormFields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const FormReservation = ({ reservation, handleSuccess, reload, setReload }) => {
  let theme = useTheme();
  const navigate = useNavigate();
  const [locale] = useState("en-gb");
  const { cid } = useParams();
  const { role, adminOn } = useAuth();

  const { register, handleSubmit, setValue, getValues, formState } = useForm({
    resolver: yupResolver(formSchema),
  });
  const {
    state: { Names: sites, selected: siteInfo },
    fetchSiteNames: fetchSites,
  } = useSite();
  const [error, setError] = useState();
  const {
    state: { selected: company },
    fetchOne: fetchCompany,
  } = useCompany();
  const { create, edit } = useReservation();
  useEffect(() => {
    if (role === "Admin" || role === "Company") fetchCompany(cid);
  }, [cid, fetchCompany, role]);
  useEffect(() => {
    if (role === "Site") {
      setValue("siteId", adminOn?.id);
    }
  }, [adminOn, role, setValue]);
  useEffect(() => {
    if (role === "Company" || role === "Admin") fetchSites(cid, 0);
  }, [cid]);
  const onSubmit = async (values) => {
    values.startDate
      ? (values.startDate = CalUtcWithFormat(values.startDate))
      : (values.startDate = reservation?.startDate);

    values.endDate
      ? (values.endDate = CalUtcWithFormat(values.endDate))
      : (values.endDate = reservation?.endDate);

    try {
      if (!values.siteId) {
        setError({ title: "You must select site at first" });
      } else {
        if (reservation) await edit(reservation?.id, values);
        else await create(values);
        handleSuccess();
        // setReload(!reload);
      }
    } catch (error) {
      setError({ title: error.errors.message });
      console.error(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      {error && (
        <Alert severity="error" sx={{ m: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      )}
      <Card
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
        }}
      >
        <Grid container spacing={2} columns={{ xs: 2, sm: 2, md: 2 }}>
          {(role === "Admin" || role === "Company") && (
            <Grid item xs={1}>
              <span style={{ fontSize: "12px" }}>Company</span>

              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "290px",
                  borderRadius: "8px",
                  textAlign: "center",
                  marginTop: "20px",
                }}
              >
                {company?.companyName}
              </Box>
            </Grid>
          )}
          {role === "Site" && (
            <Grid item xs={1}>
              <span style={{ fontSize: "12px" }}>Company</span>

              <Box
                sx={{
                  borderBottom: "1px solid gray",
                  width: "290px",
                  borderRadius: "8px",
                  textAlign: "center",
                  marginTop: "20px",
                }}
              >
                {siteInfo?.company?.companyName}
              </Box>
            </Grid>
          )}

          {FormFields.map((f, index) => (
            <Grid item xs={1} key={index}>
              {role === "Site" && f.name === "siteId" && (
                <Grid item xs={1}>
                  <span style={{ fontSize: "12px" }}>Site</span>

                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginTop: "20px",
                    }}
                  >
                    {adminOn?.siteName}
                  </Box>
                </Grid>
              )}
              {f.select && (
                <FormControl
                  sx={{
                    width: theme.dimensions.width,
                    mt: theme.dimensions.mt,
                    mb: theme.dimensions.mb,
                    display: role === "Site" ? "none" : "",
                  }}
                  error={f.name === "siteId"}
                >
                  <span style={{ fontSize: "12px" }}>
                    {f.label}
                    <>*</>
                  </span>
                  <Select
                    sx={{
                      mt: theme.dimensions.mt,
                    }}
                    error={!!formState?.errors[f.name]}
                    inputProps={{
                      ...register(f?.name),
                    }}
                    size="small"
                    defaultValue={reservation?.[f.name] || ""}
                  >
                    {sites?.map((s, index) => (
                      <MenuItem key={index} value={s.id}>
                        {s.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {f.textField && (
                <FormControl>
                  <span style={{ fontSize: "12px" }}>{f.label}</span>
                  <TextField
                    error={
                      !!formState?.errors[f.name] ||
                      (f.required &&
                        !formState.dirtyFields?.[f.name] &&
                        !reservation)
                    }
                    helperText={
                      formState?.errors[f.name]?.message ||
                      (f.required &&
                      !formState.dirtyFields?.[f.name] &&
                      !reservation
                        ? "This field is required"
                        : "")
                    }
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor:
                            f.required &&
                            !formState.dirtyFields?.[f.name] &&
                            !reservation
                              ? "red"
                              : "",
                        },
                      },
                    }}
                    inputProps={{
                      ...register(f.name, {
                        required: f.required ? "This field is required" : false,
                      }),
                    }}
                    defaultValue={reservation?.[f.name] || ""}
                    required={f.required}
                    type={f.type}
                    size="small"
                  />
                </FormControl>
              )}
              {f.date && (
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={locale}
                >
                  <FormControl
                    components={["DateRangePicker"]}
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb,
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>{f.label}</span>
                    <DateTimePicker
                      sx={{ mt: 1 }}
                      error={!!formState?.errors[f.name]}
                      onChange={(date) => setValue(f.name, date)}
                      defaultValue={dayjs(
                        newValueConvert(reservation?.[f.name])
                      )}
                      slotProps={{
                        textField: {
                          error: formState?.errors[f.name]?.message,
                          helperText: (
                            <p style={{ color: "#d32f2f" }}>
                              {formState?.errors[f.name]?.message}
                            </p>
                          ),
                          size: "small",
                        },
                      }}
                    />
                  </FormControl>
                </LocalizationProvider>
              )}
            </Grid>
          ))}
        </Grid>
      </Card>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: theme.color.grayBackground,
            color: theme.color.dark,
            "&:hover": { background: `${theme.color.gray50}` },
          }}
        >
          Discard
        </Button>
        <Button
          variant="contained"
          type="submit"
          sx={{
            backgroundColor: theme.color.blackBackground,
            ml: theme.dimensions.ml,
            "&:hover": { background: `${theme.color.black}` },
            mx: 2,
          }}
        >
          {reservation ? <>Update</> : <>Add</>} Reservation
        </Button>
      </Box>
    </form>
  );
};

export default FormReservation;
